export enum HrHolidayCalendarModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
